import ButtonLink, { ButtonType } from "./ButtonLink";

export { ButtonLink, ButtonType };

export default ButtonLink;
